export const DEFAULT_PORTAL_HOSTNAME = "ROOT";
